<script>
import { afterUpdate, createEventDispatcher } from 'svelte'

  const isDebug = new URLSearchParams(window.location.search).get('debug') === 'true'
  const log = (...args) => isDebug && console.log(...args)

  export let name = 'James Boyce'
  export let role = 'CEO & Founder'
  export let mobile = '0444 000 111'
  export let email = 'james'
  export let specialEvent = '0'
  export let bannerPlacement = 'above'

  let el

  const dispatch = createEventDispatcher()

  // Generate the raw HTML string with all conditional comments preserved
  function generateSignatureHTML() {
    const bannerRow = `<tr>
        <td style="padding: ${bannerPlacement === 'below' ? '28px 0 0 0' : '0'};">
          <a href="https://grumpystudios.com" target="_blank" title="Visit Grumpy Studios website" style="display: block;">
            <!--[if mso]>
            <img src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/banner.png" alt="Grumpy Studios - immersive elsewheres" width="478" height="113" style="display: block; border: 0; outline: none;" />
            <![endif]-->
            <!--[if !mso]><!-->
            <img src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/banner.png" alt="Grumpy Studios - immersive elsewheres" style="display: block; width: 478px; max-width: 478px; height: auto; image-rendering: crisp-edges;" />
            <!--<![endif]-->
          </a>
        </td>
      </tr>`;

    let html = `<!--[if !mso]><!-->
    <div style="display:none;font-size:1px;color:#ffffff;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;">
      Contact details for ${name} at Grumpy Studios - Creating immersive elsewheres through cutting-edge technology and creative storytelling
    </div>
    <!--<![endif]-->
    <br>
    <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; width: 502px;">
      ${bannerPlacement === 'above' ? bannerRow : ''}
      <tr>
        <td style="padding: ${bannerPlacement === 'above' ? '28px' : '0'} 0 0 0;">
          <a href="https://grumpystudios.com" target="_blank" title="Visit Grumpy Studios website" style="display: block;">
            <!--[if mso]>
            <v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:142px;height:21px;">
              <v:fill type="frame" src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/logo.png" />
            </v:rect>
            <![endif]-->
            <!--[if !mso]><!-->
            <img src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/logo.gif" alt="Grumpy Studios" style="display:block;height:21px;width:auto;" border="0" />
            <!--<![endif]-->
          </a>
        </td>
      </tr>
      <tr>
        <td style="padding: 26px 0 0 0;">
          <p style="margin: 0; padding: 0; font-size: 12px; line-height: 1.2; color: #000000;">
            <strong style="text-transform: uppercase; font-size: 12px;">${name.toUpperCase()}</strong><br />
            <span style="font-size: 12px;">${role}</span><br />
            <span style="font-size: 12px;">M ${mobile}</span><br />
            <span style="font-size: 12px;">E <a href="mailto:${email}@grumpystudios.com" style="color: #000000; text-decoration: none;">${email}@grumpystudios.com</a></span>
          </p>
        </td>
      </tr>
      <tr>
        <td style="padding: 14px 0 0 0;">
          <p style="margin: 0; padding: 0; font-size: 12px; line-height: 1.2; color: #000000; -webkit-text-size-adjust: 100%;">
            <a href="https://grumpystudios.com" target="_blank" title="Visit Grumpy Studios website" style="color: #000000; text-decoration: none; font-size: 12px; -webkit-text-size-adjust: 100%;">grumpystudios.com</a>
          </p>
        </td>
      </tr>
      ${bannerPlacement === 'below' ? bannerRow : ''}
    </table>
    <div style="clear: both; height: 20px;">&nbsp;</div>`;

    if (specialEvent === '1') {
      html += `<div style="font-family: Arial; font-size: 10pt; color: #000; width: 100%; padding: 0px 0px 0px 0px; vertical-align: middle;">
        <div style="font-family: Arial; font-size: 10pt; color: #000; width: 100%; padding: 0px 0px 0px 0px; vertical-align: middle;"><img alt="International Women's Day logo" src="https://grumpysailor---internal.s3.ap-southeast-2.amazonaws.com/edm/gs-email-signature/international-womens-day2024.png" style="width: 100%; max-width: 700px; height: auto;" /></div>
      </div>
      <div style="font-family: Arial; font-size: 10pt; color: #000; width: 100%; padding: 0px 0px 0px 0px; vertical-align: middle;">
        <p style="font-family: Arial; font-size: 7.4pt; color: #000; width: 100%; padding: 0px 0px 0px 0px; margin: 0; vertical-align: middle; text-align: center; max-width: 700px;"><em>60% of our fire power comes from our inspiring female crew mates. Happy IWD from Grumpy Sailor, celebrating women today and every day #inspireinclusion</em></p>
      </div>
      <p>&nbsp;</p>`;
    }

    html += '<p>&nbsp;</p>';
    return html;
  }

  afterUpdate(() => {
    if (!el) return
    log('EmailSignaturePreview afterUpdate triggered')
    const signatureHTML = generateSignatureHTML()
    log('Generated signature HTML:', signatureHTML)
    dispatch('render', signatureHTML)
  })

</script>

<style>
h2 {
  margin: 3rem 0 0 0;
  padding-bottom: 1rem;
  text-align: center;
  border-bottom: 1px solid #666;
  font-size: 1rem;
  text-transform: uppercase;
}

.preview-area-wrapper {
  display: flex;
  justify-content: center;
  padding: 15px 0 ;
  background-color: #CCC;
  overflow-x: scroll;
}

@media (max-width: 768px) {
  .preview-area-wrapper {
    justify-content: left;
  }
}

.preview-area {
  width: 502px;
  min-width: 580px;
  background-color: #ffffff;
  padding: 24px;
  box-shadow: 2px 4px 4px rgba(0,0,0,0.05);
}
</style>

<h2>Email Signature Preview</h2>
<div class="preview-area-wrapper">
  <div class="preview-area" bind:this={el}>
    <!-- START EMAIL SIGNATURE HTML CODE -->
    <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, sans-serif; width: 502px;">
      {#if bannerPlacement === 'above'}
      <tr>
        <td style="padding: 0;">
          <a href="https://grumpystudios.com" target="_blank" title="Visit Grumpy Studios website" style="display: block;">
            <!--[if mso]>
            <img src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/banner.png" alt="Grumpy Studios - immersive elsewheres" width="478" height="113" style="display: block; border: 0; outline: none;" />
            <![endif]-->
            <!--[if !mso]><!-->
            <img src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/banner.png" alt="Grumpy Studios - immersive elsewheres" style="display: block; width: 478px; max-width: 478px; height: auto; image-rendering: crisp-edges;" />
            <!--<![endif]-->
          </a>
        </td>
      </tr>
      {/if}
      <tr>
        <td style="padding: {bannerPlacement === 'above' ? '28px' : '0'} 0 0 0;">
          <a href="https://grumpystudios.com" target="_blank" title="Visit Grumpy Studios website" style="display: block;">
            <!--[if mso]>
            <v:rect xmlns:v="urn:schemas-microsoft-com:vml" fill="true" stroke="false" style="width:142px;height:21px;">
              <v:fill type="frame" src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/logo.png" />
            </v:rect>
            <![endif]-->
            <!--[if !mso]><!-->
            <img src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/logo.gif?v={Date.now()}" alt="Grumpy Studios" style="display:block;height:21px;width:auto;" border="0" />
            <!--<![endif]-->
          </a>
        </td>
      </tr>
      <tr>
        <td style="padding: 26px 0 0 0;">
          <p style="margin: 0; padding: 0; font-size: 12px; line-height: 1.2; color: #000000;">
            <strong style="text-transform: uppercase; font-size: 12px;">{name.toUpperCase()}</strong><br />
            <span style="font-size: 12px;">{role}</span><br />
            <span style="font-size: 12px;">M {mobile}</span><br />
            <span style="font-size: 12px;">E <a href="mailto:{email}@grumpystudios.com" style="color: #000000; text-decoration: none;">{email}@grumpystudios.com</a></span>
          </p>
        </td>
      </tr>
      <tr>
        <td style="padding: 14px 0 0 0;">
          <p style="margin: 0; padding: 0; font-size: 12px; line-height: 1.2; color: #000000; -webkit-text-size-adjust: 100%;">
            <a href="https://grumpystudios.com" target="_blank" title="Visit Grumpy Studios website" style="color: #000000; text-decoration: none; font-size: 12px; -webkit-text-size-adjust: 100%;">grumpystudios.com</a>
          </p>
        </td>
      </tr>
      {#if bannerPlacement === 'below'}
      <tr>
        <td style="padding: 28px 0 0 0;">
          <a href="https://grumpystudios.com" target="_blank" title="Visit Grumpy Studios website" style="display: block;">
            <!--[if mso]>
            <img src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/banner.png" alt="Grumpy Studios - immersive elsewheres" width="478" height="113" style="display: block; border: 0; outline: none;" />
            <![endif]-->
            <!--[if !mso]><!-->
            <img src="https://grumpystudios---internal.s3.ap-southeast-2.amazonaws.com/edm/email-signature/banner.png" alt="Grumpy Studios - immersive elsewheres" style="display: block; width: 478px; max-width: 478px; height: auto; image-rendering: crisp-edges;" />
            <!--<![endif]-->
          </a>
        </td>
      </tr>
      {/if}
    </table>
    <div style="clear: both; height: 20px;">&nbsp;</div>
    {#if specialEvent === '0'}
      <!-- -->
    {:else if specialEvent === '1'}
      <div style="font-family: Arial; font-size: 10pt; color: #000; width: 100%; padding: 0px 0px 0px 0px; vertical-align: middle;">
        <div style="font-family: Arial; font-size: 10pt; color: #000; width: 100%; padding: 0px 0px 0px 0px; vertical-align: middle;"><img alt="International Women's Day logo" src="https://grumpysailor---internal.s3.ap-southeast-2.amazonaws.com/edm/gs-email-signature/international-womens-day2024.png" style="width: 100%; max-width: 700px; height: auto;" /></div>
      </div>
      <div style="font-family: Arial; font-size: 10pt; color: #000; width: 100%; padding: 0px 0px 0px 0px; vertical-align: middle;">
        <p style="font-family: Arial; font-size: 7.4pt; color: #000; width: 100%; padding: 0px 0px 0px 0px; margin: 0; vertical-align: middle; text-align: center; max-width: 700px;"><em>60% of our fire power comes from our inspiring female crew mates. Happy IWD from Grumpy Sailor, celebrating women today and every day #inspireinclusion</em></p>
      </div>
      <p>&nbsp;</p>
    {/if}
    <p>&nbsp;</p>
    <!-- END EMAIL SIGNATURE HTML CODE -->
  </div>
</div>
